if ($('.sentence-dropdown-slide').length) {
  var index = 0;
  $('.sentence-dropdown__submit--next').on('click',function(){
    index = $('.sentence-dropdown-slide').index($(this).parent().parent());
    $($('.sentence-dropdown-slide')[index]).removeClass('active');
    $($('.sentence-dropdown-slide')[index + 1]).addClass('active');
    $($('.sentence-dropdown-progress-item')[index + 1]).addClass('done');
  });

  $('.sentence-dropdown__submit--prev').on('click',function(){
    index = $('.sentence-dropdown-slide').index($(this).parent().parent());
    $($('.sentence-dropdown-slide')[index]).removeClass('active');
    $($('.sentence-dropdown-slide')[index - 1]).addClass('active');
    $($('.sentence-dropdown-progress-item')[index]).removeClass('done');
  });

  $('.sentence-dropdown-progress__btn').on('click',function(){
    index = $('.sentence-dropdown-progress-item').index($(this).parent());
    $('.sentence-dropdown-slide').removeClass('active');
    $($('.sentence-dropdown-slide')[index]).addClass('active');
    $('.sentence-dropdown-progress-item').removeClass('done');
    for(var i = 0; i <= index; i++){
      $($('.sentence-dropdown-progress-item')[i]).addClass('done');
    }
  });
}